import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { initializePushNotifications, unregisterPushNotifications } from '../services/pushNotifications';

export function usePushNotifications() {
    const { status } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (status === 'authenticated') {
            initializePushNotifications(navigate);
        } else if (status === 'unauthenticated') {
            unregisterPushNotifications();
        }
    }, [status, navigate]);
}
